"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useLoadedNavigation_exports = {};
__export(useLoadedNavigation_exports, {
  useLoadedNavigation: () => useLoadedNavigation,
  useOptionalNavigation: () => useOptionalNavigation
});
module.exports = __toCommonJS(useLoadedNavigation_exports);
var import_native = require("@react-navigation/native");
var import_react = require("react");
var import_router = require("../router/router");
function useLoadedNavigation() {
  var { navigationRef } = (0, import_router.useOneRouter)();
  var navigation = (0, import_native.useNavigation)();
  var isMounted = (0, import_react.useRef)(true);
  var pending = (0, import_react.useRef)([]);
  (0, import_react.useEffect)(function() {
    isMounted.current = true;
    return function() {
      isMounted.current = false;
    };
  }, []);
  var flush = (0, import_react.useCallback)(function() {
    if (isMounted.current) {
      var pendingCallbacks = pending.current;
      pending.current = [];
      pendingCallbacks.forEach(function(callback) {
        callback(navigation);
      });
    }
  }, [
    navigation
  ]);
  (0, import_react.useEffect)(function() {
    if (navigationRef.current) {
      flush();
    }
  }, [
    flush,
    navigationRef
  ]);
  var push = (0, import_react.useCallback)(function(fn) {
    pending.current.push(fn);
    if (navigationRef.current) {
      flush();
    }
  }, [
    flush,
    navigationRef
  ]);
  return push;
}
function useOptionalNavigation() {
  var [navigation, setNavigation] = (0, import_react.useState)(null);
  var loadNavigation = useLoadedNavigation();
  (0, import_react.useEffect)(function() {
    loadNavigation(function(nav) {
      return setNavigation(nav);
    });
  }, [
    loadNavigation
  ]);
  return navigation;
}
//# sourceMappingURL=useLoadedNavigation.js.map
